export const apiHandler = async (apiCall) => {
  try {
    const response = await apiCall();
    return {
      success: true,
      data: response.data,
      ...(response.message ? { message: response.message } : {}),
    };
  } catch (error) {
    const message =
      error.response?.data?.error?.message ||
      error.response?.data?.message ||
      error.message ||
      'Something went wrong';

    console.log("FULL ERROR:", error);

    console.log(
      "ERROR RESPONSE:",
      error.response
    );

    console.log(
      "ERROR DATA:",
      error.response?.data
    );

    return {
      success: false,
      message,
      code: error.response?.data?.error?.code,
    };
  }
};

export const unwrapData = (result) => {
  if (!result?.success) return null;
  return result.data?.data ?? result.data;
};
